module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAAXNSR0IArs4c6QAAAM1JREFUSA3tVLsKhDAQHB9F8FFqkdbO//+PNIH8hIUGIgiKd6sELHeLg0MyTSxmMtlJnOz8Akzs+w5rLfq+h9aaqbppuYS9riu2bcM8zxLZxRUZiXd/CJLRIwzZZ4pOlteD/b7oSqoV+uM5CCFctOM44L3nSFAUBeq6RmaMOalWfolhGFB2XYdlWVg+NAlNT6esqoqlIW7TNMgk7U1xOefQti3GcWQZRdL7Xl2aKN6teE3RiSOLgv+MLs/vc1GtSCGqINp8mqaru5RSIq8PSKFCgMyTFNkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-column-unfold@2x.png
// module id = 2wUb
// module chunks = 16